export const arrayBOBLocations = [
 [
					"1",
					" Sky Services ",
					"34.3328360",
					"35.7267810",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"2",
					"100 Warde Cell",
					"33.6154380",
					"35.4827910",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"3",
					"100 Warde Cell 2",
					"33.6328560",
					"35.4964310",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"4",
					"2 B Multitech",
					"33.5592060",
					"35.3914260",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"5",
					"2 B Multitech  2",
					"33.5661560",
					"35.3897620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"6",
					"3 Points",
					"33.8659530",
					"35.5208130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"7",
					"3baid Cell",
					"33.6400620",
					"35.4284190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"8",
					"3S Group - 1",
					"33.5656734",
					"35.3733936",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"9",
					"3S Group - 2",
					"33.5697308",
					"35.3775601",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"10",
					"3S Group - 4",
					"33.5183790",
					"35.3679530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"11",
					"3S Group - 6",
					"33.5589600",
					"35.3789970",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"12",
					"3S Group - 9",
					"33.5621000",
					"35.3782700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"13",
					"3S Group 8",
					"33.5691070",
					"35.3785670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"14",
					"5 C",
					"33.9071160",
					"35.5897290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"15",
					"A and N",
					"33.2040220",
					"35.3297530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"16",
					"A ZONE",
					"33.4100320",
					"35.4785890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"17",
					"A.M. Store ",
					"33.5641770",
					"35.3971770",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"18",
					"A2Z Computer",
					"33.6306640",
					"35.7935280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"19",
					"A2Z Trading",
					"34.2002330",
					"36.3555070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"20",
					"Abboud Cell",
					"33.6395260",
					"35.7258440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"21",
					"Abboud For General Trading",
					"33.4992890",
					"35.4291700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"22",
					"Abboud For Trading And Services ",
					"33.9206730",
					"35.6339490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"23",
					"Abed Cell",
					"33.8555730",
					"35.5162440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"24",
					"Abi Assaf",
					"34.1208600",
					"35.6489100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"25",
					"Abi Saab For Trading",
					"33.7933910",
					"35.5653900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"26",
					"Abo Al Afkar Library",
					"33.5075050",
					"35.4476670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"27",
					"Abou Fadi Mini Market ",
					"33.9867290",
					"36.1352080",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"28",
					"ABSEGA",
					"33.5555500",
					"35.5555500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"29",
					"ABZ Baraa",
					"33.7633890",
					"35.8840050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"30",
					"Access Telecommunications",
					"34.0289670",
					"35.6291190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"31",
					"Ace Designe And Printing Center S.A.R.L",
					"33.8965340",
					"35.5323030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"32",
					"ACS Advanced Computer Systems",
					"33.8556640",
					"35.5386190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"33",
					"Ad Production ",
					"34.4437030",
					"35.8346990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"34",
					"Adams Cell",
					"33.8488460",
					"35.6560640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"35",
					"Adkom",
					"33.8945010",
					"35.5536450",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"36",
					"AFHIL",
					"33.8926730",
					"35.5409610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"37",
					"AFHIL 2",
					"33.8950310",
					"35.5272510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"38",
					"Agha Cell",
					"34.4986070",
					"35.9938930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"39",
					"Ahmad Mobile",
					"33.7407610",
					"35.4536090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"40",
					"Al Amer Cell",
					"34.5176850",
					"35.9782840",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"41",
					"Al Boustan For General Trading",
					"33.6220700",
					"35.4030960",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"42",
					"Al Danaf Cell",
					"33.8097900",
					"35.6925200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"43",
					"Al Ghabeh Station",
					"33.8839570",
					"35.6511870",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"44",
					"Al Ghadir",
					"33.4102830",
					"35.4794040",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"45",
					"Al Hajj For General Trading ",
					"33.8857150",
					"35.7734790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"46",
					"Al Hajj For General Trading 2",
					"33.9292190",
					"35.6311163",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"47",
					"AL HERMEL SERVICES",
					"34.3928390",
					"36.3935360",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"48",
					"Al Iqariya",
					"33.6272930",
					"35.7855150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"49",
					"Al Mawassem For Tourism S.A.L.",
					"33.8747770",
					"35.5181230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"50",
					"Al Mina Office for General Services",
					"34.4522000",
					"35.8159833",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"51",
					"Al Moughrabi For Computers",
					"33.7979620",
					"35.8243350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"52",
					"Al Nassir Office For General Services",
					"33.7533300",
					"35.5403200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"53",
					"Al Sheikh",
					"33.7050880",
					"35.9070900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"54",
					"Al Yasamin 2",
					"33.2812610",
					"35.3473530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"55",
					"Al Zouabi For General Services",
					"34.3972640",
					"35.8297560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"56",
					"Alaa Ibrahim For Trading ",
					"34.4185330",
					"35.9320480",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"57",
					"Albatros",
					"33.6895120",
					"35.5127350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"58",
					"Ali Cell",
					"33.6277700",
					"35.8082040",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"59",
					"Ali Shop",
					"33.9241400",
					"36.0494200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"60",
					"Ali Telecom",
					"33.8282160",
					"35.5080700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"61",
					"Ali Telecom 2",
					"33.7927980",
					"35.4822970",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"62",
					"ALIMAR GROUP ",
					"33.8932390",
					"35.5580420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"63",
					"Allo Beirut",
					"33.8962630",
					"35.4791020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"64",
					"Allo Beirut 2",
					"33.8953010",
					"35.4876150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"65",
					"Allo Beirut 4",
					"33.8942570",
					"35.4768040",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"66",
					"Alma",
					"33.4678930",
					"35.3193710",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"67",
					"AM Telecom",
					"33.8063160",
					"35.6033470",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"68",
					"Amal Jewelry",
					"33.8480040",
					"35.5059240",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"69",
					"AMG",
					"33.8947980",
					"35.4799720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"70",
					"AMIR PHONE SERVICES",
					"33.8862850",
					"35.5408340",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"71",
					"Amitours",
					"33.9321200",
					"35.6122400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"72",
					"AMK",
					"34.4828190",
					"36.0134740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"73",
					"Amro Trading",
					"34.4254090",
					"35.8388380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"74",
					"Andalus",
					"34.5212650",
					"36.1991850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"75",
					"Anthony Cell",
					"33.9926300",
					"35.6539710",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"76",
					"Anthony Cell 2",
					"33.8817370",
					"35.5356700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"77",
					"Antoine Saliba Market",
					"33.8518700",
					"36.0060980",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"78",
					"A-Phone",
					"33.9863690",
					"35.6359520",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"79",
					"Arida For General Trading",
					"34.3742990",
					"35.8457380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"80",
					"Arnous Services",
					"33.9904660",
					"35.6387470",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"81",
					"Around The World",
					"33.8442840",
					"35.7326210",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"82",
					"ASG",
					"33.8555560",
					"35.5755950",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"83",
					"Assanaa Stationery",
					"33.8791720",
					"35.5057360",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"84",
					"Atat Travel",
					"33.8420980",
					"35.4982440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"85",
					"Attieh For General Trading ",
					"33.1993830",
					"35.3040810",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"86",
					"Auto Ecole Modern",
					"33.9256800",
					"35.6360290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"87",
					"Awam Service",
					"33.5277090",
					"35.8340570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"88",
					"Awkar Cell",
					"33.9546330",
					"35.6190333",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"89",
					"Ayach Travel",
					"34.5415480",
					"36.0693370",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"90",
					"AZ Express Services",
					"33.8977960",
					"35.4941070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"91",
					"AZHAR SERVICES",
					"33.8134290",
					"35.8547510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"92",
					"Azrak Tours",
					"33.7068400",
					"35.9186900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"93",
					"B - Cell",
					"34.0247630",
					"35.6294880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"94",
					"Baaloul Services",
					"33.5912500",
					"35.7511200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"95",
					"Badi Net",
					"33.8932330",
					"35.5481500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"96",
					"Bakkour Cell",
					"34.4144070",
					"35.9203660",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"97",
					"Banaafoul Phone",
					"33.4821350",
					"35.4238450",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"98",
					"Barelec",
					"33.9923250",
					"35.6436610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"99",
					"Batal Cell",
					"33.8987120",
					"35.4864440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"100",
					"Bayloun  Cell",
					"33.8509990",
					"35.5216100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"101",
					"Beaino Connection",
					"33.9827260",
					"35.7635400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"102",
					"Bee Cell",
					"33.8847790",
					"35.4995940",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"103",
					"Best Life",
					"34.3852700",
					"36.0293800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"104",
					"Best Life - 2",
					"34.4033070",
					"36.0317760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"105",
					"Biba Cell",
					"33.8393160",
					"35.5167760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"106",
					"Bick Data",
					"33.9179040",
					"35.6738890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"107",
					"Bilal Cell",
					"33.8878060",
					"35.5052300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"108",
					"Bilal El Mir",
					"33.8893000",
					"35.4853800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"109",
					"Bizri For Money Transfer",
					"33.5465680",
					"35.3729690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"110",
					"Blue Ray Cell ",
					"33.8916717",
					"35.5625805",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"111",
					"Bluetooth",
					"33.7700200",
					"35.9006500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"112",
					"BOB - ACHRAFIEH - SAYDEH",
					"33.8879440",
					"35.5245560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"113",
					"BOB - ACHRAFIEH - SIOUFI",
					"33.8868500",
					"35.5231500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"114",
					"BOB - AIN EL ROUMANEH",
					"33.8624660",
					"35.5244830",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"115",
					"BOB - ANTELIAS",
					"33.9055330",
					"35.5784000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"117",
					"BOB - BAYYADA",
					"33.9050320",
					"35.6566690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"118",
					"BoB - Becharre",
					"34.2514511",
					"36.0072658",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"119",
					"BOB - BEIRUT PORT",
					"33.9034490",
					"35.5368420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"120",
					"BOB - BOURJ HAMMOUD",
					"33.8954000",
					"35.5432000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"121",
					"BOB - CHIAH",
					"33.8588000",
					"35.5138170",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"122",
					"BOB - Chouweifat",
					"33.8043060",
					"35.5072860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"123",
					"BOB - CHTAURA",
					"33.8108830",
					"35.8580500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"124",
					"BOB - CORNICHE  EL MAZRAA",
					"33.8814430",
					"35.4870650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"125",
					"BOB - ELYSSAR",
					"33.9259330",
					"35.6308000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"126",
					"BOB - FOCH",
					"33.8984410",
					"35.5064900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"127",
					"BOB - GEFINOR",
					"33.8985210",
					"35.4871160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"128",
					"BOB - GHAZIR",
					"34.0178200",
					"35.6663790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"129",
					"BOB - HAMRA",
					"33.8952230",
					"35.4862200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"130",
					"BoB - Horch Tabet",
					"33.8712000",
					"35.5353330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"131",
					"BOB - JAL EL DIB",
					"33.9055060",
					"35.5784390",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"132",
					"BOB - JAL EL DIB SQUAR",
					"33.9097210",
					"35.5820690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"133",
					"Bob - jbeil voie 13",
					"34.1268840",
					"35.6504020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"134",
					"BOB - JDEIDEH",
					"33.8916320",
					"35.5575980",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"135",
					"BOB - JOUNIEH",
					"33.9832890",
					"35.6319800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"136",
					"BOB - JOUNIEH - GHADIR",
					"33.9791660",
					"35.6291260",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"137",
					"BOB - KASLIK",
					"33.9816730",
					"35.6171980",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"138",
					"BOB - KFARAAKA",
					"34.2971780",
					"35.8336230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"139",
					"BOB - KFARDEBIAN",
					"33.9908944",
					"35.7301743",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"140",
					"BOB - MAR ELIAS",
					"33.8816570",
					"35.4909280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"141",
					"BOB - NAHR",
					"33.8978500",
					"35.5334330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"142",
					"BOB - RAS BEIRUT",
					"33.8918800",
					"35.4837200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"143",
					"BOB - RIYAD EL SOLOH",
					"33.8960360",
					"35.5028100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"144",
					"BOB - SAIDA",
					"33.5637220",
					"35.3747790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"145",
					"BoB - Sidani",
					"33.8958830",
					"35.4771000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"146",
					"BoB - Sin El Fil (El Hayek)",
					"33.8721240",
					"35.5415040",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"147",
					"BOB - TARIK EL JDIDEH",
					"33.8717670",
					"35.4997200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"148",
					"BOB - TRIPOLI - BANK STRT",
					"34.4364850",
					"35.8363380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"149",
					"BOB - TYR",
					"33.2854830",
					"35.2242670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"150",
					"BOB - ZOUK MEKAYEL",
					"33.9741520",
					"35.6156660",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"151",
					"BOB - ZOUK MOSBEH",
					"33.9519830",
					"35.6238500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"152",
					"BOB -BATROUN",
					"33.9420830",
					"35.7818000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"153",
					"Bob Cell",
					"33.4376400",
					"35.4161820",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"154",
					"BoB Finance -  Tyre Al Ramel",
					"33.2709790",
					"35.1996600",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"155",
					"BoB Finance - ABC Verdun",
					"33.8843239",
					"35.4845180",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"156",
					"BoB Finance - Achrafieh",
					"33.8897750",
					"35.5376040",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"157",
					"BoB Finance - Ataya",
					"33.8880980",
					"35.5172410",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"158",
					"Bob Finance - Bauchrieh",
					"33.8872000",
					"35.5549333",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"159",
					"BoB Finance - BEIRUT CITY CENTER",
					"33.8628234",
					"35.5299342",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"160",
					"BoB Finance - Bristol",
					"33.8920130",
					"35.4835130",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"161",
					"Bob Finance - Chehabieh",
					"33.2393450",
					"35.3728330",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"162",
					"Bob Finance - Dekwaneh",
					"33.8768900",
					"35.5461000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"163",
					"BoB Finance - Dora",
					"33.8941000",
					"35.5519810",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"164",
					"BoB Finance - Faddoul Supermarket",
					"33.9782720",
					"35.6255740",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"165",
					"BoB Finance - Ghobeiry",
					"33.8591770",
					"35.5091440",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"166",
					"BOB FINANCE - HAZMIEH",
					"33.8596480",
					"35.5342990",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"167",
					"Bob Finance - Horsh Tabet",
					"33.8710980",
					"35.5365000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"168",
					"BOB FINANCE - JBEIL",
					"34.1196190",
					"35.6496300",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"169",
					"BoB Finance - Mansourieh",
					"33.8576854",
					"35.5678277",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"170",
					"Bob Finance - Nabatieh",
					"33.4274930",
					"35.4624300",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"171",
					"BoB Finance - Nahr",
					"33.8961850",
					"35.5332250",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"172",
					"BoB Finance - Saida",
					"33.5639440",
					"35.3747320",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"173",
					"BoB Finance - Sassine",
					"33.8870490",
					"35.5208810",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"174",
					"Bob Finance - SIDANI",
					"33.8971540",
					"35.4842310",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"176",
					"BoB Finance - TRIPOLI SQUARE MALL",
					"34.4183081",
					"35.8289841",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"177",
					"BoB Finance - TRIPOLI TALL",
					"34.4384334",
					"35.8376619",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"178",
					"BoB Finance - Zahle",
					"33.8448960",
					"35.9057380",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"179",
					"BoB Finance - Zalka",
					"33.9014660",
					"35.5712720",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"180",
					"BOB -M3-TRIPOLI-HH",
					"34.4335900",
					"35.8360820",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"181",
					"BOB-M3 - 4A",
					"33.5626650",
					"35.3868670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"182",
					"BOB-M3- AMIOUN CELL - AMIOUN",
					"34.2991560",
					"35.8084400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"183",
					"BOB-M3- BAALBEK CITY - KS",
					"34.0095310",
					"36.2067420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"184",
					"BOB-M3- BOURJ EL BARAJNI - MS",
					"33.8413660",
					"35.5074460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"185",
					"BOB-M3- BURJ EL BARAJNI - AZ",
					"33.8424150",
					"35.4980620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"186",
					"BOB-M3- EL GHADIR FUEL CENTER",
					"33.8596950",
					"35.4973370",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"187",
					"BOB-M3- EL KOBBEH - HM",
					"34.4303860",
					"35.8498560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"188",
					"BOB-M3- ESCO CELL SARL - ADMA",
					"34.0217550",
					"35.6470680",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"189",
					"BOB-M3- ESCO CELL SARL 2 - JBEIL",
					"34.1171930",
					"35.6523130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"190",
					"BOB-M3- F.ALTOUFAILY - BAALBEK CITY",
					"34.0071210",
					"36.2091250",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"191",
					"BOB-M3- JOUMAA TRADING - WADI KHALED",
					"34.6176160",
					"36.3794980",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"192",
					"BOB-M3- RABIH EL SAYED - HALBA",
					"34.5440360",
					"36.0798350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"193",
					"Bob-M3 SAL",
					"33.8849060",
					"35.5476800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"194",
					"BOB-M3- SUZANNE FOR TRADING  - JOUNIEH",
					"33.9866400",
					"35.6392600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"195",
					"BOB-M3- ZGHARTA CITY - ST",
					"34.3980630",
					"35.8944370",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"196",
					"BOB-M3-AGROPHYT - JRAN",
					"34.2235460",
					"35.7127030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"197",
					"BOB-M3-AL BARBIR - IM",
					"33.8866770",
					"35.5060960",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"198",
					"BOB-M3-AL JNAH - AN",
					"33.8641130",
					"35.4838680",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"199",
					"BOB-M3-Al Tal - WM",
					"34.4365770",
					"35.8385660",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"200",
					"BOB-M3-ARSAL-MB",
					"34.1828750",
					"36.4205350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"201",
					"BOB-M3-BAALBEK - MH",
					"33.9999080",
					"36.1958870",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"202",
					"BOB-M3-BAR ELIAS-IB",
					"33.7738220",
					"35.8966890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"203",
					"BOB-M3-BATROUN - FD",
					"34.2575530",
					"35.6653800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"204",
					"Bob-M3-BEDDAWI-NG",
					"34.4477310",
					"35.8736950",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"205",
					"Bob-M3-BSHERRI -DG",
					"34.2492600",
					"36.0108180",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"206",
					"BOB-M3-BURJ HAMMOUD - MS",
					"33.8878730",
					"35.5392510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"207",
					"BOB-M3-C and I SARL - KFARHATA",
					"34.3816600",
					"35.9000700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"208",
					"BOB-M3-CHTAURA - KM",
					"33.8131530",
					"35.8554680",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"209",
					"BOB-M3-DAHYEH-AS",
					"33.8593670",
					"35.5119550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"210",
					"Bob-M3-DENNYEH-RS",
					"34.3837130",
					"36.0247570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"211",
					"BOB-M3-EL MASRI TRADING - MINYEH",
					"34.4858670",
					"35.9452860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"212",
					"BOB-M3-ELECTRICAL SOLAR 1",
					"33.4377690",
					"35.4105080",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"213",
					"BOB-M3-ELECTRICAL SOLAR 2",
					"33.3631940",
					"35.4973800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"214",
					"BOB-M3-Haret Hreik - MR",
					"33.8480870",
					"35.5091100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"215",
					"BOB-M3-HARET HREIK-AS",
					"33.8479960",
					"35.5091100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"216",
					"BOB-M3-J.P. ALUMINUM  - ZOUK MOSBEH",
					"33.9501930",
					"35.6237700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"217",
					"Bob-M3-JABAL MOHSEN-AS",
					"34.4392170",
					"35.8548010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"218",
					"BOB-M3-Jbeil - HK",
					"34.1225700",
					"35.6470120",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"219",
					"Bob-M3-JBEIL -MA",
					"34.1213578",
					"35.6483790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"220",
					"BOB-M3-JDEIDEH - MN",
					"33.8952010",
					"35.5654700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"221",
					"Bob-M3-KESERWEIN-CK",
					"33.9521330",
					"35.6192350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"222",
					"BOB-M3-KORNET CHEHWAN - BE",
					"33.9199790",
					"35.6189230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"223",
					"BOB-M3-MASTITA - JS",
					"34.1093270",
					"35.6535190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"224",
					"Bob-M3-MERYATA -HI",
					"34.4176980",
					"35.9295430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"225",
					"BOB-M3-MERYATA -RS2",
					"34.4181670",
					"35.9303700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"226",
					"BOB-M3-NEW RAWDA - EH",
					"33.8790523",
					"35.5565361",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"227",
					"BOB-M3-NOUR GENERAL TRADING - QALAMOUN",
					"34.3865850",
					"35.7827640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"228",
					"BOB-M3-REINA CELL-EL CHOUEIFAT",
					"33.8051070",
					"35.5072820",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"229",
					"Bob-M3-Saida -HT",
					"33.5643690",
					"35.3766290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"230",
					"Bob-M3-SAIDA -SB",
					"33.5569690",
					"35.3758620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"231",
					"BOB-M3-SOUR - HJ",
					"33.2705800",
					"35.2035600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"232",
					"BOB-M3-SUNFEED - AMCHIT",
					"34.1364900",
					"35.6422860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"233",
					"BOB-M3-TAALABAYA - AA",
					"33.8176120",
					"35.8745510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"234",
					"BOB-M3-TOUFIC BARAKAT TRADING - MAZRAET YACHOUH",
					"33.9304890",
					"35.6323650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"235",
					"Bob-M3-TRIPOLI - AD",
					"34.4475170",
					"35.8592680",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"236",
					"Bob-M3-Tripoli-IB",
					"34.4491500",
					"35.8148500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"237",
					"BOB-M3-WAJDI MAHMOUD EL HALABI-HALBA",
					"34.5446620",
					"36.0770650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"238",
					"BOB-M3-WEHBE CELL",
					"34.3514060",
					"35.7314830",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"239",
					"BOB-M3-YARA TRADING- ABDEH",
					"34.5106038",
					"35.9695183",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"240",
					"Bob-M3-ZAHLEH-MZ",
					"33.8142400",
					"35.8638170",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"241",
					"BOB-M3-ZAKARIA FOR COMMUNICATION - QALAMOUN",
					"34.3867000",
					"35.7889820",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"242",
					"BOB-M3-ZAKARIA FOR COMMUNICATION 2 - AL TAL",
					"34.4375150",
					"35.8373030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"243",
					"Bonne Note",
					"33.9519950",
					"35.6725110",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"244",
					"Boussi Cell",
					"33.1174790",
					"35.4302000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"245",
					"Bring Cell",
					"33.9098870",
					"35.5894050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"246",
					"Bro And Bro s.a.r.l",
					"33.8919590",
					"35.5110800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"247",
					"Broumana Cell ",
					"33.8864920",
					"35.6387600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"248",
					"Bucks Money Transfer ",
					"34.3872050",
					"35.9000272",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"249",
					"Business and Managment",
					"33.8694820",
					"35.5792020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"250",
					"Byblos Energy Company ",
					"34.1246680",
					"35.6470570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"251",
					"BYBLOS MIDPOINT",
					"34.1210680",
					"35.6493190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"252",
					"CASH FAST",
					"33.8934250",
					"35.5491890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"253",
					"Cash Fast - 3",
					"33.9172440",
					"35.5876540",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"254",
					"Cash Fast - 4",
					"33.8920031",
					"35.4713754",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"255",
					"Cash Fast - 5",
					"34.0231790",
					"35.6597290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"256",
					"Cash Fast 2",
					"33.8934250",
					"35.5491890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"257",
					"CASH FLOW S.A.R.L",
					"33.9220210",
					"35.6822160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"258",
					"Castle Services",
					"34.4095210",
					"36.0150430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"259",
					"Cedars For General Trading ",
					"33.7897680",
					"35.5018070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"260",
					"CELL PLUS",
					"33.8831140",
					"35.6296230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"261",
					"Celluland 2",
					"33.9132610",
					"35.5862770",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"262",
					"Central Al Massnaa For Cell",
					"33.7054090",
					"35.9190740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"263",
					"Centrum Market",
					"34.0855900",
					"36.1234500",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"264",
					"Chadi Nassar Trading",
					"33.8333375",
					"35.9973990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"265",
					"Challita Services",
					"34.0136300",
					"35.7928100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"266",
					"CHARBEL SAID TRADING  3",
					"33.8946430",
					"35.5415340",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"267",
					"CHARBEL SAID TRADING 1",
					"33.8959260",
					"35.5521390",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"268",
					"CHARBEL SAID TRADING 2",
					"34.1250160",
					"35.6566130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"269",
					"CHATILA TRUST",
					"33.8951550",
					"35.4798240",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"270",
					"Choughari Services",
					"33.2748130",
					"35.2097140",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"271",
					"City Com SAL",
					"34.4439000",
					"35.8253500",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"272",
					"Class - ABC Achrafieh",
					"33.8891250",
					"35.5202120",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"273",
					"CLASS - DownTown",
					"33.8979230",
					"35.5057670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"274",
					"CLASS - Mar Elias",
					"33.8867330",
					"35.4936220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"275",
					"CLASS - Mar Elias 2",
					"33.8867330",
					"35.4936220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"276",
					"CLASS - Mar Elias 3",
					"33.8867330",
					"35.4936220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"277",
					"CLASS - Tyr",
					"33.2918200",
					"35.2291300",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"278",
					"Class - Verdun",
					"33.8843610",
					"35.4848440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"279",
					"Class Nabatieh 2",
					"33.3767890",
					"35.4733050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"280",
					"Classic Phone",
					"33.9090660",
					"36.0094833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"281",
					"Cle - Jihad Yassin 3",
					"33.8879220",
					"35.4832400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"282",
					"Cle - Jihad yassine",
					"33.8853530",
					"35.4948520",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"283",
					"Click Mobile",
					"33.8852720",
					"35.5060550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"284",
					"Click S.A.R.L ",
					"33.8852720",
					"35.5060550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"285",
					"Click Services",
					"33.4202170",
					"35.3348540",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"286",
					"Code Library",
					"33.9472600",
					"35.5974200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"287",
					"Coinbase ",
					"33.9713360",
					"35.6086160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"288",
					"CompuSam 1",
					"33.9002830",
					"35.6232833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"289",
					"COMPUSAM 3",
					"33.8862930",
					"35.6398420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"290",
					"Computer  World",
					"33.8473000",
					"36.0060500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"291",
					"Computer Al Majd",
					"33.7814100",
					"35.5281300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"292",
					"Computop",
					"33.8477000",
					"35.9301833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"293",
					"CONSEIL VOYAGE",
					"33.8516350",
					"35.5484430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"294",
					"Cyber Space Net",
					"34.4438370",
					"35.8263010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"295",
					"Dalta Plus S.A.R.L",
					"33.8175600",
					"35.8475600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"296",
					"dany Abou Jaoudeh",
					"33.8902050",
					"35.6683080",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"297",
					"Darwich Cell",
					"33.8424570",
					"35.5125610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"298",
					"Diana Travel ",
					"33.8942300",
					"35.5628400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"299",
					"DigiCall",
					"33.8734660",
					"36.1039666",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"300",
					"DigiCall 3",
					"33.8532300",
					"35.9334400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"301",
					"DIGICALL 4",
					"33.8574620",
					"36.0247710",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"302",
					"Digital cell",
					"33.8927000",
					"35.5493500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"303",
					"Dima Trading",
					"33.5726430",
					"35.7251790",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"304",
					"Discotell",
					"33.8596230",
					"35.5223380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"305",
					"DOHA SERVICES CENTER",
					"33.7634370",
					"35.4636460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"306",
					"DONALEED S.A.R.L",
					"33.8956480",
					"35.4820560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"307",
					"Dory Cell",
					"33.8667660",
					"35.5399000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"308",
					"Double M For General Trading",
					"33.5895650",
					"35.3948890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"309",
					"Doumit Est.",
					"34.2991400",
					"35.8176900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"310",
					"E B Real Estate",
					"33.8972430",
					"35.5790760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"311",
					"E.S Technology",
					"33.9647710",
					"35.6102290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"312",
					"Eagle Travel and  Tourism",
					"33.9003500",
					"35.4930666",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"313",
					"Eagle-Tech",
					"33.6465300",
					"35.8777400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"314",
					"Easy Tech ",
					"33.9681090",
					"35.6074880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"315",
					"Easy Tech - Maamltein",
					"33.9940000",
					"35.6406490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"316",
					"ECONN - SYNDICATE OF ENGINEERS",
					"34.4301680",
					"35.8253620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"317",
					"El  Eit Trading",
					"34.2602560",
					"36.3984270",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"318",
					"El Amana For General Trading ",
					"34.5990500",
					"36.3470000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"319",
					"El Amer Cell 2",
					"34.4762010",
					"36.1825670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"320",
					"El Halabi Cell",
					"34.4564240",
					"35.8319300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"321",
					"El Hayek For General Trading",
					"34.5492740",
					"36.0771160",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"322",
					"Electro Cell",
					"33.8469200",
					"35.9001000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"323",
					"Electro Key",
					"33.9889060",
					"35.6434650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"324",
					"Electro Pro",
					"33.8398660",
					"36.0373090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"325",
					"Eleventech",
					"33.8583170",
					"35.5636290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"326",
					"Elio Cigars",
					"33.9639390",
					"35.6054970",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"327",
					"Elite Cell",
					"33.8690700",
					"35.5255790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"328",
					"Elmundo Cell",
					"33.6663990",
					"35.8269630",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"329",
					"EMC",
					"33.9988660",
					"36.1880610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"330",
					"Epic Zone ",
					"33.3869940",
					"35.4958770",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"331",
					"ERR Solutions ",
					"33.9849540",
					"35.6306280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"332",
					"ES Technology 2",
					"33.9568840",
					"35.6076640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"333",
					"ESB",
					"34.2524060",
					"35.6627480",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"334",
					"Esco Cell",
					"33.8408440",
					"35.5307830",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"335",
					"Eskanian Trading",
					"34.3270230",
					"35.7311630",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"336",
					"EST. Maya For General Trading and Services",
					"33.8056330",
					"35.8141130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"337",
					"Ets. Hayek Pour Le Commerce",
					"33.8846300",
					"35.5533700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"338",
					"EXCHANGE AND TRAVEL ",
					"33.2824340",
					"35.5175140",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"339",
					"Expert - Roni El Turk",
					"33.8953180",
					"35.5493330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"340",
					"Expertel 1",
					"33.8699080",
					"35.5249840",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"341",
					"Expertel 3",
					"33.8078120",
					"35.5981880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"342",
					"Ezzo Cell",
					"33.8646070",
					"35.4851010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"343",
					"Fadi Freiha Cell",
					"33.7847650",
					"35.9926810",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"344",
					"Fakih Group Concord S.A.R.L",
					"33.8808510",
					"35.4904300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"345",
					"Fakih Group Concord S.A.R.L 2",
					"33.4535840",
					"35.2840050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"346",
					"Farah Market 2",
					"33.9469020",
					"35.5977850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"347",
					"Farah Trading",
					"34.2466797",
					"35.6624355",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"348",
					"Five Stars Phone",
					"33.8722510",
					"35.5454280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"349",
					"Fneish Cell",
					"33.2716370",
					"35.3115180",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"350",
					"FOOD center S.A.R.L ",
					"33.6257680",
					"35.5371560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"351",
					"For All",
					"33.8790120",
					"35.5020400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"352",
					"FPC-2",
					"33.8638710",
					"35.5242460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"353",
					"G M",
					"33.8556630",
					"35.5750390",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"354",
					"G.B.S Books And Stationery",
					"33.8191640",
					"35.5599750",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"355",
					"G.Njeim Cell 4",
					"34.0226900",
					"35.6474720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"356",
					"GAEL CELL",
					"33.9123980",
					"35.5863530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"357",
					"Gamma 2022 ",
					"33.9589100",
					"35.6837100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"358",
					"Gee Gas And Oil",
					"33.1981070",
					"35.2286620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"359",
					"Ghandour Information Technology",
					"33.3744750",
					"35.4887990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"360",
					"Ghandour Shop ",
					"33.5636680",
					"35.3969040",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"361",
					"Ghio",
					"34.4409710",
					"35.8280640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"362",
					"Global Cell",
					"33.8979430",
					"35.4794280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"363",
					"Global Wings",
					"33.6149350",
					"35.4592860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"364",
					"Globetech",
					"34.3695670",
					"35.8991590",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"365",
					"GMK",
					"34.2517320",
					"36.0098770",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"366",
					"Gold - Cell",
					"33.8525480",
					"36.0158820",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"367",
					"Golden Cell",
					"33.8794200",
					"35.5034700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"368",
					"GRAND TECH ",
					"33.8731530",
					"35.5238760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"369",
					"Gravity Mobile",
					"33.8821910",
					"35.5216740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"370",
					"Great Deal",
					"33.5131430",
					"35.3980320",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"371",
					"H.G.S Business For Services",
					"33.8495830",
					"36.0114480",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"372",
					"H.T FOR GENERAL TRADING",
					"33.4993050",
					"35.4757500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"373",
					"H2 TJD",
					"33.8704960",
					"35.5017610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"374",
					"Habib Cell",
					"34.4356600",
					"35.8389900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"375",
					"Haidar For General Services",
					"33.8194160",
					"35.8434166",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"376",
					"Hajj Market",
					"33.9525800",
					"35.6199980",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"377",
					"hajj Services",
					"33.5529120",
					"35.8247850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"378",
					"Hamieh Store",
					"33.6557060",
					"35.4345410",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"379",
					"Hamieh Store 2",
					"33.6434660",
					"35.4369870",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"380",
					"Hammoud",
					"33.5013180",
					"35.4802170",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"381",
					"HAMO CELL",
					"33.8894780",
					"35.4802310",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"382",
					"Happy Cash ",
					"33.9587900",
					"35.6198690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"383",
					"Harb Electrolight",
					"33.8946500",
					"35.4959833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"384",
					"Hariri Home Plus",
					"34.4377350",
					"35.8398570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"385",
					"HAT ZONE",
					"33.7539930",
					"35.5439300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"386",
					"Hayek Market",
					"34.3075650",
					"35.8957650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"387",
					"Hb Cell",
					"33.2074820",
					"35.2988080",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"388",
					"Hello !",
					"33.8932890",
					"35.4815050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"389",
					"Helou Travel",
					"34.4735660",
					"35.9239833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"390",
					"High Land Services",
					"33.8155763",
					"35.6080564",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"391",
					"Hijazieh Shop",
					"33.2676130",
					"35.2028850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"392",
					"HK Liquor Store ",
					"33.8640940",
					"35.5268750",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"393",
					"HMA Phones and Accessories ",
					"34.2636700",
					"36.3974740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"394",
					"Hola Cell Store",
					"33.8876110",
					"35.4899130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"395",
					"HOTSPOT MOBILE",
					"34.0066410",
					"35.6457530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"396",
					"Hussein El Ali for Commerce",
					"33.6218330",
					"35.4056000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"397",
					"HYH For General Trading And Services ",
					"33.6732720",
					"35.4235850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"398",
					"I AND G",
					"33.8787510",
					"35.5449870",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"399",
					"I AND G 2",
					"33.8591610",
					"35.5133320",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"400",
					"I Cell",
					"33.7581700",
					"35.9114100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"401",
					"I N C",
					"33.1203070",
					"35.4360300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"402",
					"I Shop - Barouk",
					"33.7095830",
					"35.6759760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"403",
					"I SMART",
					"33.8991450",
					"35.5712120",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"404",
					"I.Touch",
					"33.3902450",
					"35.4179910",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"405",
					"I_Connect Cell",
					"33.7803600",
					"35.4942070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"406",
					"I_Connect Cell 2 ",
					"33.7946990",
					"35.4881780",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"407",
					"I_CONNECT CELL 3",
					"33.7793580",
					"35.4938930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"408",
					"I-Black",
					"33.8730500",
					"35.5457030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"409",
					"Infinity Group",
					"33.8459160",
					"35.5258220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"410",
					"Integrity Travel and Tourism",
					"33.5230160",
					"35.8317166",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"411",
					"Intratel net",
					"33.8758100",
					"35.5475300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"412",
					"Israa Phone Zone",
					"33.3783160",
					"35.4835020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"413",
					"Issa For General Services",
					"33.4125310",
					"35.2801150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"414",
					"Iyad El Hajj",
					"34.4532000",
					"35.8854780",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"415",
					"J . M Trading ",
					"34.2148790",
					"35.6540160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"416",
					"J C For Business ",
					"34.1136610",
					"35.6569900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"417",
					"J.R connect",
					"33.9816210",
					"35.7018890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"418",
					"Jabtech Information and Services S.A.R.L.",
					"33.3812600",
					"35.4812100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"419",
					"Jalal Cell",
					"34.4136980",
					"35.9126560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"420",
					"JALEX TRADING",
					"33.9130610",
					"35.5862580",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"421",
					"Jalmoud Cell",
					"33.1168370",
					"35.4663990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"422",
					"Jawad Trading ",
					"33.4000530",
					"35.6822320",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"423",
					"JBK",
					"33.8507080",
					"35.5461420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"424",
					"JBK 2",
					"33.8966510",
					"35.5597100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"425",
					"JBK 3",
					"33.9111140",
					"35.7547910",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"426",
					"Jiyeh-Computer",
					"33.6777130",
					"35.4224160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"427",
					"Joel Antoine Helayel",
					"33.9196330",
					"35.6163500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"428",
					"Joken",
					"33.9501090",
					"35.6750740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"429",
					"Kalamus",
					"33.8579440",
					"35.5346790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"430",
					"Kamal For Trading",
					"33.8974050",
					"35.4816510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"431",
					"Kanso Phone ",
					"33.2498200",
					"35.3751940",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"432",
					"Kdouh Cell",
					"33.3828250",
					"35.4831080",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"433",
					"Khalifeh Trading ",
					"33.4595870",
					"35.2897920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"434",
					"Khalil Library ",
					"33.7773140",
					"35.4731000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"435",
					"KHARFANE COMMERCE",
					"34.6581460",
					"36.3447760",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"436",
					"Khat W Telephone",
					"33.8939200",
					"35.4824720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"437",
					"Khdeir Cell",
					"34.3955000",
					"36.0133890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"438",
					"Khoury Telecom",
					"33.8389020",
					"35.9101370",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"439",
					"Kobeissi Office",
					"33.8439350",
					"35.5230330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"440",
					"Kotob City",
					"33.5741360",
					"35.3847600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"441",
					"Lameh Bags",
					"33.9222790",
					"35.6064150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"442",
					"Laylo Market",
					"33.8835080",
					"35.5642300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"443",
					"Le Journal",
					"33.8918730",
					"35.5211390",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"444",
					"Leen Cell - Ankoun",
					"33.4997900",
					"35.4268340",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"445",
					"Librairie Georges Murr",
					"33.9630300",
					"35.6143600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"446",
					"librairie Joseph",
					"33.8410180",
					"35.9134160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"447",
					"Library Plus",
					"33.8760900",
					"35.5508500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"448",
					"Library Sbeity",
					"33.8900560",
					"35.4931030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"449",
					"Link",
					"34.2512160",
					"35.6647833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"450",
					"Link - Daher El Ain",
					"34.3917890",
					"35.8479570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"451",
					"Link - Petrotrade",
					"34.4500920",
					"35.8203230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"452",
					"Link (API)",
					"34.4343030",
					"35.8361690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"453",
					"Link By Econn - Al Mina Tripoli",
					"34.4402830",
					"35.8313070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"454",
					"Link Kfarsaroun",
					"34.2998890",
					"35.8252240",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"455",
					"LIT OTUL",
					"33.8882060",
					"35.5189290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"456",
					"Lord Cell",
					"33.8421330",
					"35.5082000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"457",
					"Lord Cell 4",
					"33.8494210",
					"35.5135710",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"458",
					"Loricell",
					"33.8962100",
					"35.5771300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"459",
					"Lorin Khalifeh",
					"33.4585850",
					"35.2885150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"460",
					"Loulou Cell",
					"33.8552610",
					"36.0275070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"461",
					"Luxury Phones",
					"33.7914030",
					"35.8234520",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"462",
					"M and L Bookshop",
					"34.3205600",
					"35.8072200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"463",
					"M AND N",
					"33.0764820",
					"35.3672890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"464",
					"M Stationary SARL",
					"33.8785410",
					"35.5775760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"465",
					"M.E.M",
					"33.9237590",
					"35.5924720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"466",
					"M3 - TABO CELL",
					"33.8644150",
					"35.5094540",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"467",
					"M3 -M.T.H",
					"34.1225700",
					"35.6470120",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"468",
					"M3- Mobile Net",
					"34.4987370",
					"35.9947620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"469",
					"M3- Sky Tours",
					"33.8268090",
					"35.8953270",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"470",
					"M3-EL HASSAN FOR TRADING",
					"33.2346150",
					"35.3572990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"471",
					"M3-HIJAZI BUILDING MATERIALS TRADING",
					"33.5092200",
					"35.3608430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"472",
					"M3-JOUD GADGET",
					"33.2569720",
					"35.2224550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"473",
					"M3-JOUMANA CELL",
					"33.8729270",
					"35.9643570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"474",
					"M3-KANAAN TRADING",
					"34.4552270",
					"36.0956950",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"475",
					"M3-KH SERVICES",
					"33.2688640",
					"35.2054300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"476",
					"M3-KHEIR CELL",
					"34.4834060",
					"35.9416850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"477",
					"M3-M.H. TECHNOLOGY FOR TRADING",
					"33.2372540",
					"35.3388670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"478",
					"M3-NAFEZ MOHAMAD TRADING",
					"34.6032070",
					"36.1935690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"479",
					"M3-PHONE CITY",
					"33.1226030",
					"35.4325490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"480",
					"M3-ROODY",
					"33.7938000",
					"35.4885670",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"481",
					"M3-WIMAX COMPUTEC",
					"33.3883650",
					"35.4305880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"482",
					"M3-ZEINEDDINE MOBILE",
					"33.8650760",
					"35.5094990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"483",
					"Maaliki Travel",
					"34.4356060",
					"35.8312890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"484",
					"Maamoun For General Trading",
					"33.6693404",
					"35.8269773",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"485",
					"Maamoura Services",
					"33.8403900",
					"35.5130480",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"486",
					"Maanaki 2",
					"33.2854830",
					"35.2319000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"487",
					"macadamia",
					"33.9122020",
					"35.6392940",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"488",
					"Madi Dot Com",
					"33.8648200",
					"35.6017700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"489",
					"Madi Tech",
					"33.7782290",
					"35.8936470",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"490",
					"Madina Market",
					"33.8895830",
					"35.4776760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"491",
					"Magic Cell - Hijazi",
					"33.4674010",
					"35.3158310",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"492",
					"Mahdi Awala",
					"33.3969330",
					"35.2644666",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"493",
					"Mahdi Cell",
					"33.4431880",
					"35.4928780",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"494",
					"Mahdi For General Trading",
					"33.3096880",
					"35.3479550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"495",
					"Maher Cell",
					"34.4240500",
					"35.8386800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"496",
					"Mak Store",
					"34.4454820",
					"35.8301770",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"497",
					"Mak Trade",
					"34.0607680",
					"35.7080030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"498",
					"Makke EST.",
					"33.4318500",
					"35.4513833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"499",
					"Malaeb Services",
					"33.7595700",
					"35.5658000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"500",
					"MALAK MALL",
					"33.6177850",
					"35.4448440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"501",
					"Malek Cell",
					"33.9242440",
					"35.5926380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"502",
					"MANAGERS S.A.L",
					"33.8636590",
					"35.5733090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"503",
					"MANSHEYA Square. Cell",
					"33.8453660",
					"35.5091250",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"504",
					"Markazia",
					"33.8968930",
					"35.5050990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"505",
					"Market Tariq ",
					"33.9802320",
					"35.6338580",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"506",
					"Mashghara Services",
					"33.5324800",
					"35.6550310",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"507",
					"MASRI MONEY EXPRESS S.A.L.",
					"34.4366090",
					"35.8382930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"508",
					"Mazloum Cell",
					"34.4417800",
					"35.8549200",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"509",
					"Mechmech Computers",
					"34.4721000",
					"36.1702500",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"510",
					"MED Services",
					"33.5559540",
					"35.3776050",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"511",
					"Media Agent",
					"33.8893610",
					"35.4980060",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"512",
					"Mega Telecom",
					"33.9086510",
					"35.5813260",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"513",
					"Melhem Cell",
					"33.2234310",
					"35.4645540",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"514",
					"MEM Store",
					"34.1251100",
					"35.6586100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"515",
					"MEM Store 2",
					"34.1098500",
					"35.6548410",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"516",
					"MERCURY S.A.R.L",
					"33.8947190",
					"35.5495030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"517",
					"Merheb Petroleum ",
					"34.6285870",
					"36.1258260",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"518",
					"Merhi Cell 1",
					"33.8897900",
					"35.5410460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"519",
					"Merhi Cell 2",
					"33.8923530",
					"35.5429380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"520",
					"Merhi Trading 1",
					"33.4848080",
					"35.3634290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"521",
					"Merhi Trading 2",
					"33.4511140",
					"35.3230320",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"522",
					"Mero Tel",
					"33.7533900",
					"35.5422300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"523",
					"Mero Tel 3",
					"33.7922610",
					"35.5646700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"524",
					"Mgr Services",
					"34.0070240",
					"35.6578420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"525",
					"MHD For General Trading ",
					"33.3856420",
					"35.4830760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"526",
					"Mila For General Trading ",
					"33.3875190",
					"35.4965890",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"527",
					"Miled Mansour Est.",
					"33.8773930",
					"35.5205090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"528",
					"Mina Phone",
					"33.6962050",
					"35.6411430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"529",
					"Minimarket El Kassis",
					"33.9202300",
					"35.5872600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"530",
					"Miro Cell",
					"33.8140670",
					"35.8541230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"531",
					"MK",
					"33.6817890",
					"35.5873740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"532",
					"MMJ Petroleum",
					"33.8742530",
					"35.5408010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"533",
					"MMJ Petroleum 2",
					"33.9290812",
					"35.6220324",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"534",
					"Mobaylak",
					"34.2411840",
					"36.3811790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"535",
					"Mobi mall",
					"33.8990130",
					"35.5710790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"536",
					"Mobi Plus",
					"33.8819640",
					"35.4948060",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"537",
					"Mobile and Pc",
					"33.9438640",
					"35.7912420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"538",
					"Mobile Plus Tech",
					"33.7622560",
					"35.8835820",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"539",
					"MOBILY SHOP",
					"33.8936380",
					"35.5414640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"540",
					"Mobitech",
					"33.8093960",
					"35.5977380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"541",
					"Mobytes ",
					"34.4059730",
					"35.9041780",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"542",
					"Moe-bile",
					"33.8486370",
					"35.4995720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"543",
					"Mohamad Derbas",
					"34.4402550",
					"35.8371920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"544",
					"Mohsen Computer",
					"33.8499200",
					"35.5126500",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"545",
					"Moni Phone",
					"33.8186080",
					"35.8839870",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"546",
					"Moon Light",
					"33.8177880",
					"35.8665630",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"547",
					"Morad Phone",
					"33.3261250",
					"35.4229130",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"548",
					"Mouazen Cell ",
					"33.8805040",
					"35.5404640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"549",
					"MR PHONE",
					"34.4985440",
					"35.9939930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"550",
					"Mrad Cell",
					"33.8569450",
					"35.9416440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"551",
					"Mrad Trading",
					"33.8936000",
					"35.5637910",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"552",
					"MRAD TRADING 2 ",
					"33.9805091",
					"35.7018059",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"553",
					"mroue-services",
					"33.3362960",
					"35.3404630",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"554",
					"My Family",
					"33.8758800",
					"35.4962530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"555",
					"N and N cell 1",
					"33.4840550",
					"35.3912800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"556",
					"Nahnou",
					"34.5863380",
					"36.2349090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"557",
					"Najem Cellular Service ",
					"33.3338060",
					"35.4025620",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"558",
					"Nassabein Cell",
					"33.7100600",
					"35.9048840",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"559",
					"Nassar Cell - Hussein",
					"33.8920590",
					"35.5005460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"560",
					"Naya Cell",
					"33.8735110",
					"35.5044520",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"561",
					"New Force Technology ",
					"34.1278900",
					"35.6498700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"562",
					"New System Services (Jean Assaf)",
					"33.5522050",
					"35.4035930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"563",
					"NFT",
					"33.8619600",
					"35.5181800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"564",
					"Nizam Trading",
					"33.2394920",
					"35.3973420",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"565",
					"O.A.Tech",
					"33.6200040",
					"35.4377830",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"566",
					"Ojaimi Real Estate",
					"34.2996700",
					"35.8139930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"567",
					"Oleiwan Services",
					"33.8858830",
					"35.4893490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"568",
					"PAA Cell",
					"33.9614500",
					"35.6226150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"569",
					"PALM 3",
					"33.8628060",
					"35.5232860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"570",
					"Permaweb",
					"33.2721020",
					"35.2000690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"571",
					"peter home",
					"33.5404010",
					"35.5835720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"572",
					"PHONE LINK",
					"33.8664540",
					"35.5191920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"573",
					"PhoneX",
					"33.9037840",
					"35.5822550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"574",
					"Pierre Salim Atallah Agence Immobiliere",
					"33.9807750",
					"35.6335330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"575",
					"Pixels Graphic and Computer",
					"33.8747350",
					"35.4964930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"576",
					"PLATINUM NUMBERS 2",
					"33.7779930",
					"35.4849480",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"577",
					"Polypro",
					"33.9014660",
					"35.5738140",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"578",
					"Polypro 2",
					"33.8928620",
					"35.6376650",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"579",
					"Power Bank",
					"34.0093680",
					"35.6527550",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"580",
					"PRIMATEL",
					"33.8702960",
					"35.5281030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"581",
					"Prime-Services",
					"33.8053430",
					"35.5083920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"582",
					"Primo Tesla Services",
					"33.8953860",
					"35.5633970",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"583",
					"Printon.com.lb s.a.r.l",
					"33.8807530",
					"35.5526440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"584",
					"Pro Cell Services",
					"33.6783420",
					"35.5586010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"585",
					"Q_Cell",
					"33.8541260",
					"35.5770460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"586",
					"R L R - Al Majd For Real Estate and Construction",
					"33.8260980",
					"35.7332860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"587",
					"Rahil Cell",
					"33.8754750",
					"35.5008400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"588",
					"Rajbieh Petroleum",
					"34.3945220",
					"35.8025060",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"589",
					"RAJBIEH PETROLEUM 2",
					"34.4601810",
					"36.1231930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"590",
					"Ramzi Cell and Phone",
					"33.8852300",
					"35.5372400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"591",
					"Razi Trading",
					"33.8731830",
					"35.4958666",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"592",
					"RCM S.A.R.L.",
					"33.5167120",
					"35.8297800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"593",
					"Red Cell",
					"34.1259130",
					"36.1284290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"594",
					"Rim Cell",
					"33.8949930",
					"35.4772320",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"595",
					"Rizk For General Trading - Dekwaneh",
					"33.8788890",
					"35.5446420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"596",
					"Roges Cell",
					"34.1387330",
					"35.6442666",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"597",
					"Royal Sam",
					"33.8939210",
					"35.4813660",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"598",
					"SAADE BOOKSHOP ",
					"33.9729350",
					"35.6176300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"599",
					"Saadeh Est",
					"33.9277000",
					"35.6271290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"600",
					"Safar Time S.A.R.L",
					"33.7633890",
					"35.8846680",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"601",
					"Safe Security System s.s.s.",
					"34.3868320",
					"36.0283810",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"602",
					"Safe Security System s.s.s. - 2",
					"34.4273800",
					"35.8436390",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"603",
					"Safelife",
					"34.2971320",
					"35.8634750",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"604",
					"Saha Trade",
					"34.0568370",
					"35.7197440",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"605",
					"Said Magic Cellular",
					"33.8308430",
					"35.9063570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"606",
					"Saikaly Electronics",
					"33.9794970",
					"35.6285290",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"607",
					"Salam Cell",
					"34.1895540",
					"36.4071120",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"608",
					"Salam Cell 2",
					"34.3598540",
					"36.4987250",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"609",
					"Salam Cell 3",
					"34.2233510",
					"36.3705900",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"610",
					"Salami Cell",
					"33.2414720",
					"35.3828140",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"611",
					"Saleh Cell ",
					"34.4540330",
					"35.8588880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"612",
					"Salman 1",
					"33.8493250",
					"35.5080300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"613",
					"Sam Cell - Bchamoun",
					"33.7901510",
					"35.4994010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"614",
					"Sam-Cell",
					"33.2678740",
					"35.2051270",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"615",
					"Sara Phone",
					"33.3908850",
					"35.4247480",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"616",
					"Sarrouf Group",
					"33.8681210",
					"35.5234020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"617",
					"Sava Library",
					"33.7325830",
					"35.9232833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"618",
					"Sawa",
					"33.8891810",
					"35.4796760",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"619",
					"Sayegh Station",
					"34.0357300",
					"35.6904310",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"620",
					"Sbeity Cell",
					"33.3251160",
					"35.4018860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"621",
					"Securama Plus ",
					"34.0083950",
					"35.6500880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"622",
					"Seifeddine Telecom",
					"33.8745690",
					"35.5040630",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"623",
					"Service Express",
					"33.8920590",
					"35.5005460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"624",
					"Seventy Six 76 Cell",
					"34.4507810",
					"35.8115570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"625",
					"SFG.NET",
					"34.3777210",
					"35.7991140",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"626",
					"SHAHINE MARKET",
					"33.8911990",
					"35.5685740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"627",
					"Shark Cell",
					"33.8759270",
					"35.4916100",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"628",
					"Shop Market ",
					"34.5604050",
					"36.3588570",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"629",
					"Sico Mobile and Computer",
					"34.5994440",
					"36.1551110",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"630",
					"Sim Point",
					"33.7854470",
					"35.4904640",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"631",
					"Slaiby Servicess",
					"34.0172430",
					"35.6657720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"632",
					"Sleiman Yaghi For General Trading",
					"34.4332990",
					"35.8502720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"633",
					"SMA Technology",
					"33.5573620",
					"35.3774840",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"634",
					"Smaili Cell",
					"33.6912000",
					"35.9061300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"635",
					"SMART E-SHOP",
					"33.3707790",
					"35.4923230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"636",
					"Smart Hut 2",
					"33.5637860",
					"35.4001430",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"637",
					"Smart P.C",
					"33.8063610",
					"35.6003250",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"638",
					"Smart Phone - Rahbeh",
					"34.5047920",
					"36.1439420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"639",
					"Smart Phones",
					"34.4431300",
					"35.8299700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"640",
					"Social",
					"33.8930750",
					"35.4835220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"641",
					"Souk all - TAll 1",
					"34.4367280",
					"35.8407750",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"642",
					"Souk All - Tall 2",
					"34.4366930",
					"35.8383220",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"643",
					"Speed Services",
					"33.8888530",
					"35.4784690",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"644",
					"Speed-Tech Group",
					"33.6473750",
					"35.4264280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"645",
					"Srour For General Trading",
					"33.2605620",
					"35.2707370",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"646",
					"Srour For General Trading 2 ",
					"33.2744830",
					"35.2140000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"647",
					"St Elie Library",
					"33.8804900",
					"35.5355800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"648",
					"St. Joseph Library",
					"34.2505440",
					"35.6624110",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"649",
					"STAR PHONE",
					"33.8399710",
					"35.9144940",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"650",
					"STC",
					"33.2259949",
					"35.4083048",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"651",
					"storm",
					"33.9442720",
					"35.7898790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"652",
					"STUDIO STAND BY",
					"33.9715850",
					"35.6187030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"653",
					"Sultan For General Services",
					"34.4390650",
					"35.8406790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"654",
					"Super Market Al Nasim Trading ",
					"34.4778617",
					"36.4369190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"655",
					"Supermarket Dandal",
					"34.6304050",
					"36.3279460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"656",
					"Supermarket Tannourine",
					"34.1827220",
					"35.9054230",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"657",
					"SUPERMARKET ZAHRAMAN",
					"34.5110880",
					"36.0191790",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"658",
					"SUYOOL PAYROLL",
					"33.8709013",
					"35.5230558",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"659",
					"T 2 Technology S.A.R.L",
					"33.8850410",
					"35.8747600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"660",
					"Taiba Cell ",
					"34.4885670",
					"35.9578860",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"661",
					"TAKKOUCH CELL",
					"33.8884960",
					"35.4875530",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"662",
					"Tala For Trading and General Services",
					"34.4020280",
					"36.3893800",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"663",
					"Taleb Sat",
					"34.4796930",
					"35.9348850",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"664",
					"TALIA FOR GENERAL TRADING",
					"33.2925970",
					"35.2298270",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"665",
					"Tango 1",
					"33.8148350",
					"35.8547610",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"666",
					"Tango 2",
					"33.6568800",
					"35.8850160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"667",
					"Tarek Chouhakar For Trading And Services ",
					"33.8839700",
					"35.4829210",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"668",
					"Tcharekian Trading",
					"33.8878750",
					"35.5435030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"669",
					"Tcharekian Trading 2",
					"33.8946360",
					"35.4839510",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"670",
					"Tech Tronics",
					"34.2973420",
					"35.8293770",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"671",
					"Techno Power ",
					"33.8782590",
					"35.5424970",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"672",
					"Techno-Com",
					"33.0789210",
					"35.3683160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"673",
					"TECHNOPHONE",
					"33.9756170",
					"35.6094150",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"674",
					"Tele Rock",
					"34.1050450",
					"35.6641200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"675",
					"The Mobile Shop 2",
					"33.8866500",
					"35.5243600",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"676",
					"The Mobile Shop 3",
					"33.9157520",
					"35.6018900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"677",
					"The Mobile Shop 4",
					"33.8852770",
					"35.5129910",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"678",
					"The Mobile Shop 5",
					"33.8499000",
					"35.5360080",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"679",
					"The Mobile Shop 6",
					"33.9239310",
					"35.6117330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"680",
					"THE TECHCORNER MACHAROLD",
					"33.8938750",
					"35.5616720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"681",
					"The Travel Center",
					"33.8804570",
					"35.4985000",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"682",
					"Think And Ink_Aline",
					"33.9893370",
					"35.6438160",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"683",
					"Tia Crown",
					"34.0271656",
					"36.1847048",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"684",
					"Tilia Travel",
					"34.4363520",
					"35.8314740",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"685",
					"TIO FOR GENERAL TRADING",
					"33.8147600",
					"35.8540110",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"686",
					"Tobaco House",
					"34.5877110",
					"36.0582710",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"687",
					"TONY ZIEDEH EST",
					"33.8922760",
					"35.5292090",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"688",
					"TREGEO CELL",
					"33.9879110",
					"35.6389590",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"689",
					"TriColor",
					"34.0671000",
					"35.6436400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"690",
					"Triple C",
					"33.8619350",
					"35.5204070",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"691",
					"Troll s Music",
					"33.8881520",
					"35.5591720",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"692",
					"Trust",
					"34.4328550",
					"35.8300860",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"693",
					"Twister Cell",
					"34.0074300",
					"36.2083000",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"694",
					"Uncle Bill Cell",
					"33.8968771",
					"35.4795078",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"695",
					"UNIQ Cell S.A.R.L.",
					"33.8715870",
					"35.5009330",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"696",
					"United - Sahel Alma",
					"34.0012149",
					"35.6594673",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"697",
					"United - Sarba",
					"33.9782820",
					"35.6207280",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"698",
					"United - Zalka",
					"33.9034920",
					"35.5734960",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"699",
					"Urban Connect",
					"33.9849540",
					"35.6343110",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"700",
					"URBAN LOCKER",
					"33.8672740",
					"35.9682920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"701",
					"Utilita Energy Company SARL",
					"33.8366520",
					"35.5324560",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"702",
					"Video Hut",
					"33.8930520",
					"35.5279490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"703",
					"VIRTUAL NETWORK SOLUTIONS V.N.S.",
					"33.9130550",
					"35.5855780",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"704",
					"Wadi El Taym Travel and  Tourism",
					"33.3972900",
					"35.6826200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"705",
					"Wahib Jabbour",
					"34.3556640",
					"35.7330930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"706",
					"Wakilni 1",
					"34.4203550",
					"35.8478490",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"707",
					"Wakilni 2",
					"33.4530330",
					"35.2885350",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"708",
					"Wassim Assafiri For General Trading ",
					"34.4492910",
					"35.8162810",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"709",
					"WAVES - SOUR",
					"33.2682760",
					"35.2010880",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"710",
					"Waves Cell",
					"33.7945800",
					"35.6887200",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"711",
					"WAVES CELL 2",
					"33.7687490",
					"35.7052470",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"712",
					"Wehbys Trading ",
					"34.4911690",
					"35.9548030",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"713",
					"WEHBYS TRADING - 2",
					"34.4757010",
					"35.9306010",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"714",
					"Whatsapp - Ajaltoun",
					"33.9666500",
					"35.6832700",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"715",
					"WHATSAPP CELL - KORNAYEL",
					"33.8545760",
					"35.7264190",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"716",
					"Wissam For Trading ",
					"33.3002750",
					"35.3712020",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"717",
					"WISSAM JOSEPH DOUMIT ",
					"33.9838950",
					"35.6326420",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"718",
					"Ya Hala ",
					"34.5849760",
					"36.2487900",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"719",
					"Yaakoub Trading",
					"34.5279700",
					"36.0302460",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"720",
					"Yara Cell",
					"33.8644250",
					"35.5242710",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"721",
					"Yassine Cell - Jihad",
					"33.8888660",
					"35.4979833",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"722",
					"Yassine for Services",
					"33.8473630",
					"35.5161380",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"723",
					"Yasso Communication",
					"33.8694400",
					"35.4976400",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"724",
					"Yehya Phone",
					"33.7759250",
					"35.9098990",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"725",
					"Younes Travel",
					"33.8999180",
					"35.5707210",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"726",
					"Youness",
					"33.4482730",
					"35.2867930",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"727",
					"YoYo Cell",
					"33.6318440",
					"35.5121040",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"728",
					"Z. A Group",
					"34.4364520",
					"35.8351690",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"729",
					"Z.A Group 2",
					"34.4351120",
					"35.8545180",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"730",
					"Zaayour For General Trading",
					"33.8292550",
					"35.5157300",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"731",
					"Zain Library",
					"33.8883050",
					"35.4927920",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"732",
					"Zayoun Cell",
					"33.3989260",
					"35.4200830",
					"0",
					"1000",
					"0",
					"85500000",
					"1262"
				],
				[
					"733",
					"Zibara Cell",
					"33.5672522",
					"35.3956222",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"734",
					"Ziko Trading",
					"34.4240140",
					"35.9852350",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				],
				[
					"735",
					"Ziko Trading 2 ",
					"34.4173300",
					"35.9985750",
					"0",
					"10000",
					"0",
					"855000000",
					"1262"
				]
];
